module.exports = __webpack_public_path__ + "media/images/homes/Call-a46af0497a66b41412279c094b80b77c.svg";